<template>
    <app-button color="brand-blue" size="large" @click="$emit('click')">
        <document-download-icon class="mr-2" />
        Descargar PDF
    </app-button>
</template>

<script>
import DocumentDownloadIcon from "@/components/icons/DocumentDownloadIcon.vue";

export default {
    name: "PdfDownloadButton",
    components: { DocumentDownloadIcon }
};
</script>
